@if (router.url !== "/logout" && router.url !== "/login") {
	<mat-toolbar class="toolbar">
		<mat-toolbar-row class="d-flex">
			<button
				[attr.aria-label]="_lang('side-bar')"
				id="sidenav-button"
				class="navbar-button"
				[class.navbar-button-outlined]="!sidenavControllerService.sidenavStateExpanded()"
				(click)="sidenavControllerService.toggleSidebar()"
			>
				<mat-icon class="material-symbols-rounded"> thumbnail_bar</mat-icon>
			</button>
			<a
				[attr.aria-label]="_lang('navigate-to-homescreen')"
				class="logo-container"
				routerLink="/homescreen"
				routerLinkActive="active"
			>
				<mat-icon class="logo" svgIcon="mep_logo"></mat-icon>
				<div class="logo-text">
					<span id="logo-text-pre">msg</span>
					<span id="logo-text-main">.MEP</span>
				</div>
			</a>
			<div class="d-flex flex-grow-1">
				@if (displayGlobalSearchbar) {
					<app-global-search-box class="global-search-bar"></app-global-search-box>
				}
			</div>
			<div id="settings-wrapper">
				@if (!appearanceService.experimentalFeatures.deactivateUselessNavbarButtons.signal()) {
					<a
						id="environment-container"
						[href]="
							environment?.includes('prod') ? 'https://search.mep.msg.team/' : 'https://search.test.mep.msg.team/'
						"
					>
						<img alt="Logo" class="mep-logo-image" />
						<span>{{ systemDescription }}</span>
					</a>
				}
				<div id="buttons-wrapper">
					@if (!appearanceService.experimentalFeatures.deactivateUselessNavbarButtons.signal()) {
						<a [attr.aria-label]="_lang('doc_chat')" class="navbar-button" [href]="docChatLink" target="_blank">
							<img
								[src]="docChat"
								alt="{{ _lang('doc_chat') }}"
								matTooltip="{{ _lang('doc_chat') }}"
								class="navbar-button-icon"
							/>
						</a>
					}
					@if (!appearanceService.experimentalFeatures.deactivateUselessNavbarButtons.signal()) {
						<button [attr.aria-label]="_lang('bug_report')" class="navbar-button" (click)="reportBug()">
							<mat-icon class="material-symbols-rounded" matTooltip="{{ _lang('bug_report') }}">bug_report</mat-icon>
						</button>
					}
					<button
						[attr.aria-label]="_lang('assignments-notification-dialog')"
						class="navbar-button bell-icon-link"
						(click)="openAssignmentsNotificationDialog()"
					>
						<mat-icon
							class="material-symbols-rounded"
							matBadge="{{ countNewNotifications }}"
							matBadgeOverlap="true"
							matBadgeSize="small"
						>
							notifications_active
						</mat-icon>
					</button>
				</div>
				<div>
					<button
						[attr.aria-label]="_lang('open-profile-menu')"
						[matTooltip]="_lang('open-profile-menu')"
						id="profile-picture"
						#p="mepPopover"
						[mepPopover]="settingsPopUp"
						popoverClass="profile-settings-popover ngb-popover-no-zoom"
						[autoClose]="'outside'"
					>
						<div>
							@if (isEmployeeInDB) {
								<img
									class="mep-user-icon-medium"
									[class.image-error]="!ProfilePictureComponent.imageLoadable()"
									[src]="profilePicture"
									(load)="ProfilePictureComponent.imageLoadable.set(true)"
									alt=""
								/>
								@if (!ProfilePictureComponent.imageLoadable()) {
									<img class="mep-user-icon-medium" [src]="profilePictureFallback" alt="" />
								}
							}
							@if (!isEmployeeInDB) {
								<img class="mep-user-icon-medium" [src]="profilePictureFallback" alt="" />
							}
						</div>
					</button>
					<ng-template #settingsPopUp>
						<div id="settings-popup-header">
							<div class="profile">
								<img
									class="mep-user-icon-medium"
									[class.image-error]="!ProfilePictureComponent.imageLoadable()"
									[src]="profilePicture"
									alt=""
								/>
								@if (!ProfilePictureComponent.imageLoadable()) {
									<img class="mep-user-icon-medium" [src]="profilePictureFallback" alt="" />
								}
							</div>
							<div class="sph-name">
								<span>{{ userName }}</span>
								<span>{{ email?.toLowerCase() }}</span>
							</div>
						</div>
						<div id="spb-buttons">
							<button class="navigation-list-button" (click)="openColorSchemeSettings(); p.close()">
								{{ "mep.components.appearance-dialog.appearance" | translate }}
							</button>
							<a
								*appRequiresPermission="'CREATE'; entity: 'MAINTENANCE_GUIDELINE'"
								class="navigation-list-button"
								rel="noreferrer"
								target="_self"
								routerLink="/admin-homescreen"
								(click)="p.close()"
							>
								{{ "mep.components.homescreen.administration" | translate }}
							</a>
							<a
								*appRequiresPermission="'READ_MY'; entity: 'EMPLOYEE'; employeeId: userId"
								[hidden]="userId === undefined"
								class="navigation-list-button"
								routerLink="/employee-edit/{{ userId }}"
								(click)="p.close()"
							>
								{{ _lang("my-data") }}
							</a>
							@if (currentAuthenticatedStatus) {
								<button class="navigation-list-button nlb-primary" (click)="logout(); p.close()">
									{{ "mep.components.navigation.logout" | translate }}
								</button>
							}
						</div>
						<div id="spb-links">
							@if (guideline) {
								<a
									class="navigation-list-link"
									(click)="downloadGuideline(guideline)"
									*appRequiresPermission="'READ'; entity: 'MAINTENANCE_GUIDELINE'"
								>
									{{ "mep.components.navigation.maintenance_guideline" | translate }}
								</a>
							}
							<div class="spb-links-shared-row">
								<a
									class="navigation-list-link"
									rel="noreferrer"
									target="_blank"
									href="{{ userManualLink }}"
									(click)="p.close()"
								>
									{{ "mep.components.navigation.user_manual" | translate }}
								</a>
								<span class="spbl-separator">·</span>
								<a
									class="navigation-list-link"
									(click)="reportBug(); p.close()"
									tabindex="0"
									(keydown.enter)="reportBug(); p.close()"
								>
									{{ _lang("bug_report") }}
								</a>
							</div>
							<a class="navigation-list-link" rel="noreferrer" target="_blank" href="{{ mepSharePointLink }}">
								{{ _lang("sharepoint_link") }}
							</a>
						</div>
						<div id="spb-deployment-info">
							<mat-icon class="material-symbols-rounded"> circle</mat-icon>
							<div>{{ systemDescription }}</div>
							@if (userRoles !== undefined) {
								<div id="spbdi-userRoles">{{ "mep.components.employee.role" | translate }}: {{ userRoles }}</div>
							}
							<a
								[attr.aria-label]="_lang('release-info')"
								id="release-info-link"
								target="_blank"
								rel="noopener noreferrer"
								[href]="releaseNotesLink"
								class="spb-links-shared-row navigation-list-link"
							>
								<span>V {{ analyticsService.mepVersion.trim().length > 0 ? analyticsService.mepVersion : "N/A" }}</span>
								<span class="spbl-separator">·</span>
								<span
									>{{ "mep.components.general.deployed-at" | translate }}: {{ deployedDate | date: "dd.MM.yyyy" }}</span
								>
							</a>
						</div>
					</ng-template>
				</div>
				<!--remove with news-notification-->
				@if (isLineManager) {
					<app-news-notification class="float-end" [messageKey]="'pv-email'" insertDate="22.07.2025">
						<div></div>
					</app-news-notification>
				}
			</div>
		</mat-toolbar-row>
	</mat-toolbar>
}
